"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalysisTypeSchema = exports.AnalysisType = void 0;
const zod_1 = require("zod");
var AnalysisType;
(function (AnalysisType) {
    AnalysisType["OperatingPoint"] = "OperatingPoint";
    AnalysisType["Transient"] = "Transient";
    AnalysisType["Boundary"] = "Boundary";
    AnalysisType["BusFunction"] = "BusFunction";
    AnalysisType["PowerTraversal"] = "PowerTraversal";
    AnalysisType["NetDrive"] = "NetDrive";
    AnalysisType["NetDriveInfo"] = "NetDriveInfo";
    AnalysisType["NetDriveScenario"] = "NetDriveScenario";
    AnalysisType["NetDriveTraversal"] = "NetDriveTraversal";
    AnalysisType["NetDriveVoltage"] = "NetDriveVoltage";
    AnalysisType["NetDriveLegacy"] = "NetDriveLegacy";
    AnalysisType["DriveNetwork"] = "DriveNetwork";
    AnalysisType["NetAnnotation"] = "NetAnnotation";
    AnalysisType["NetworkAnalysisSegmentation"] = "NetworkAnalysisSegmentation";
    AnalysisType["SegmentedNetworkAnalysis"] = "SegmentedNetworkAnalysis";
    AnalysisType["SpiceNetworkAnalysis"] = "SpiceNetworkAnalysis";
    AnalysisType["LogicalBus"] = "LogicalBus";
    AnalysisType["LogicalBusEnumeration"] = "LogicalBusEnumeration";
    AnalysisType["ComponentFunction"] = "ComponentFunction";
    AnalysisType["CircuitState"] = "CircuitState";
    AnalysisType["OperatingState"] = "OperatingState";
    AnalysisType["SignalNetworkBuild"] = "SignalNetworkBuild";
    AnalysisType["PowerNetworkBuild"] = "PowerNetworkBuild";
    AnalysisType["PossibleValuesBoundary"] = "PossibleValuesBoundary";
    AnalysisType["DriveModeNetDependency"] = "DriveModeNetDependency";
    AnalysisType["NetBoundaryMap"] = "NetBoundaryMap";
    AnalysisType["DifferentialPairComponentAnalysis"] = "DifferentialPairComponentAnalysis";
    AnalysisType["DifferentialPairEnumerationAnalysis"] = "DifferentialPairEnumerationAnalysis";
    AnalysisType["DifferentialPairValidationAnalysis"] = "DifferentialPairValidationAnalysis";
})(AnalysisType || (exports.AnalysisType = AnalysisType = {}));
exports.AnalysisTypeSchema = zod_1.default.nativeEnum(AnalysisType);
//# sourceMappingURL=AnalysisType.js.map